<template>
    <div>
    <div>
        <el-button class="reserch" size="medium" @click="reserch()">刷新</el-button>
        <el-table
            class="tablemo"
            ref="listview"
            :height='tabHeight'
            :data="taskList"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            align="center"
                border
                style="width: 100%">
                <el-table-column         
                    label="任务"
                    width="200px"
                    prop="taskid"></el-table-column>
                <el-table-column
                    label="任务名"
                    width="150"
                    prop="taskname"></el-table-column>
                <el-table-column
                    label="调度周期"
                    prop="taskcron"></el-table-column>
                <el-table-column
                    label="最后调度时间"
                    width="200px"
                    prop="lasttime"></el-table-column>
                <el-table-column
                    label="最后调度状态"
                    prop="laststate"></el-table-column>
                <el-table-column
                    label="设置"
                    width="150px"
                    prop="editable">
                    <template slot-scope="scope">
                        <el-button
                        v-if="scope.row.editable===true"
                        size="mini"
                        @click="handleEditCorn(scope.$index, scope.row)">任务CRON变更</el-button>
                        <el-button
                            v-else
                            disabled
                            size="mini"
                        >禁用</el-button>
                    </template>
            </el-table-column>
                <el-table-column
                    label="日志"
                    prop="logable">
                    <template slot-scope="scope">
                        <el-button
                        v-if="scope.row.logable"
                        size="mini"
                        @click="handleEditLogable(scope.$index, scope.row)">任务日志</el-button>
                        <el-button
                            v-else
                            disabled
                            size="mini"
                        >禁用</el-button>
                    </template>
            </el-table-column>
        </el-table>
        <editCorn v-show="cornVisio" ref="dialogCorn" :taskData="taskData"></editCorn>
        <tasklog ref="dialogLog" :taskData="taskData"></tasklog>
    </div>
    </div>
</template>
<script>
import Utility from '@/components/mixin.js'
import editCorn from './EditCorn.vue'
import tasklog from './TaskLog.vue'
import axios from 'axios'
import Navbar from '@/components/Base/Navbar'
export default {
    mixins: [Utility],
    components: {
        Navbar,
        editCorn,
        tasklog
    },
    data () {
        return {
             tabHeight:window.innerHeight - 170,
             taskList:[],//任务列表
             cornVisio:false,
             taskData:{},//当前操作的任务对象
        }
    },
    created(){
        //console.log(this.$application_name);
    },
    watch:{
        tabHeight:{
            immediate:true,
            handler:function(newVal){
               // console.log(newVal)
                this.tabHeight = newVal
                //console.log(this.tabHeight);
            }
        }
    },
    mounted () {
        window.onresize = () => {
            return (() => {
                 this.tabHeight =window.innerHeight - 170;
            })()
        }
        // //初始化用户支付表头
        // this.tasklist_fields = [
        //     { key: 'taskid', label: '任务id',fix:false },
        //     { key: 'taskname', label: '任务名' ,fix:false},
        //     { key: 'taskcron', label: '调度周期',fix:false },
        //     { key: 'lastmodifytime', label: '最后调度时间',fix:false },
        //     { key: 'laststate', label: '最后调度状态' ,fix:false},
        //     { key: 'editable', label: '是否允许动态设置corn' ,fix:false},
        //     { key: 'logable', label: '是否允许查看日志' ,fix:false},
        // ]
        //初始化请求表数据
        this.initData(this.usrinfo.token)
        //console.log(this.usrinfo.token)
    },
    methods: {
        //初始化表格数据
        initData (ptoken) {
        axios.get('/mananger/task/list?token=' + ptoken)
            .then(response => {
            let res = response.data
           // console.log(res)
            if(res.code === 1){
                this.taskList = res.data
            }else{
                 this.err_process(res.code, '[' + res.code + ']' + res.message)
            }
            })
            .catch(err => {
              console.error(err)
              this.err_process('AAAA', '获取数据异常:[AAAA]' + err)
            })
        }, 
        //CORN变更
        handleEditCorn(index, row){
            //console.log(index,row);
            this.taskData = row
            this.$refs.dialogCorn.dialogCornVisible=true
        },
        //查看任务日志
        handleEditLogable(index,row){
            console.log(index,row);
            this.taskData = row
            this.$refs.dialogLog.dialogLogVisible = true
        },
        //刷新界面
        reserch(){
            location.reload()
        }
    }
}
</script>
<style scoped>
.reserch{
    position: relative;
    left:calc(100% - 70px);
    top: 0px;
    margin-bottom: 2px;
}
</style>